import React from "react";
import { connect } from "react-redux";
import { FadeLoader } from "react-spinners";
import { css } from "@emotion/core";
import Header from "../../components/Header";
import FilterTab from "./components/FilterTab";
import SwitchBar from "./components/SwitchBar";
import Firebase from "../../firebasehelper";
import ReactHtmlParser from "react-html-parser";
import AddOfferModal from "../../components/AddOfferModal";
import "./index.css";
const override = css`
  position: absolute;
  top: 48%;
  left: 48%;
  radius: 2px;
  height: 15px;
  width: 5px;
  display: block;
  margin: 0 auto;
  border-color: grey;
`;
const filter_array = (array) => {
  let arr = [];
  console.log("array", array);
  array.forEach((item) => {
    arr[item.id] = item;
  });
  return arr;
};
class Offer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      offers: [],
      business_offers: [],
      personal_offers: [],
      loading: true,
      tag: "",
      deactive_arr: [],
      offer_type: "personal",
    };
  }
  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      console.log("brand", brand);
      Firebase.getBrandDataByID(brand, async (res) => {
        console.log("brand_data", res);
        this.setState({
          logo: res.logo,
          icon: res.icon,
          brand_name: res.name,
          brand_url: res.url,
          business_offers: res.business_offers ? res.business_offers : [],
          personal_offers: res.personal_offers ? res.personal_offers : [],
          hex: res.hex,
          is_property_brand: res.is_property_brand
            ? res.is_property_brand
            : false,
          is_business_offers_need: res.is_business_offers_need
            ? res.is_business_offers_need
            : false,
        });
      });
    }
    Firebase.getTop10Perks((res) => {
      this.setState({ top_10perks: res });
      console.log("top_10perks", res);
    });
    Firebase.getAllOffers((res) => {
      this.setState({ loading: false });
      let offers = filter_array(res);
      this.setState({ offers });
    });
    Firebase.getAllDeactiveOffers((res) => {
      let deactive_arr = [];
      if (res) deactive_arr = res;
      this.setState({ deactive_arr });
    });
  }
  filter_View = (tag) => {
    console.log("tag", tag);
    if (tag === "all") this.setState({ tag: "" });
    else this.setState({ tag });
  };
  switchOffer = (offer_type) => {
    console.log("offer", offer_type);
    this.setState({ offer_type });
  };
  toggleActive = (id) => {
    let { deactive_arr } = this.state;
    deactive_arr[id] = !deactive_arr[id];
    Firebase.updateDeactiveOffers(deactive_arr);
  };
  showPersonalOffer = () => {
    const { offers, personal_offers, loading, tag, deactive_arr, top_10perks } =
      this.state;
    console.log("personal_offers", personal_offers);
    return (
      <div className="content">
        {loading && <i className="fa fa-4x fa-sync fa-spin text-muted" />}
        {!loading && <FilterTab filter_View={this.filter_View} tag={tag} />}
        {!loading && (
          <div className="tiles">
            {tag !== "Top 10" &&
              offers.map((item, index) => {
                if (item.category.includes(tag) && !deactive_arr[item.id])
                  return (
                    <div
                      id={index}
                      className="deal"
                      style={{
                        backgroundImage: `url(${item.dealHeroImage})`,
                      }}
                    >
                      <div className="deal-caption">
                        <b>{item.name}</b>
                        <span>{item.membershipBenefit}</span>
                      </div>
                      <div
                        className="deal-logo"
                        style={{ backgroundImage: `url(${item.logo})` }}
                      ></div>
                    </div>
                  );
              })}
            {tag === "Top 10" &&
              top_10perks.map((item, index) => {
                return (
                  <div
                    id={index}
                    className="deal"
                    style={{
                      backgroundImage: `url(${item.dealHeroImage})`,
                    }}
                  >
                    <div className="deal-caption">
                      <b>{item.name}</b>
                      <span className="top10">
                        {ReactHtmlParser(item.membershipBenefit)}
                      </span>
                    </div>
                    <div
                      className="deal-logo"
                      style={{ backgroundImage: `url(${item.logo})` }}
                    ></div>
                  </div>
                );
              })}
            {personal_offers.map((item, index) => {
              if (item.category.includes(tag))
                return (
                  <div
                    id={index}
                    className="deal"
                    style={{
                      backgroundImage: `url(${item.dealHeroImage})`,
                    }}
                  >
                    <div className="deal-caption">
                      <b>{item.name}</b>
                      <span>{item.membershipBenefit}</span>
                    </div>
                    <div
                      className="deal-logo"
                      style={{ backgroundImage: `url(${item.logo})` }}
                    ></div>
                  </div>
                );
            })}
            {/* <button
              type="button"
              className="btn btn-secondary add_btn"
              data-toggle="modal"
              data-target="#add_offer"
            >
              +Add
            </button> */}
          </div>
        )}
      </div>
    );
  };
  showBusinessOffer = () => {
    const { business_offers, loading } = this.state;
    return (
      <div className="content">
        {loading && <i className="fa fa-4x fa-sync fa-spin text-muted" />}
        {!loading && (
          <div className="tiles">
            {business_offers.map((item, index) => {
              return (
                <div
                  id={index}
                  className="deal"
                  style={{
                    backgroundImage: `url(${item.dealHeroImage})`,
                  }}
                >
                  <div className="deal-caption">
                    <b>{item.name}</b>
                    <span>{item.membershipBenefit}</span>
                  </div>
                  <div
                    className="deal-logo"
                    style={{ backgroundImage: `url(${item.logo})` }}
                  ></div>
                </div>
              );
            })}
            <button
              type="button"
              className="btn btn-secondary add_btn"
              data-toggle="modal"
              data-target="#add_offer"
            >
              +Add
            </button>
          </div>
        )}
      </div>
    );
  };
  addOffer = (provider, info, logo_img, bg_img) => {
    const { brand, offer_type, business_offers, personal_offers, tag } =
      this.state;
    console.log("provider", provider);
    console.log("info", info);
    console.log("logo_img", logo_img);
    console.log("bg_img", bg_img);
    this.setState({ loading: true });
    Firebase.addOfferImage(offer_type, provider, logo_img, bg_img).then(
      (res) => {
        console.log("image res", res);
        const offer = {
          dealHeroImage: res.background,
          name: provider,
          membershipBenefit: info,
          logo: res.logo,
        };
        if (offer_type === "personal") {
          offer.category = tag;
          personal_offers.push(offer);
          this.setState({ personal_offers });
          Firebase.updateBrandDataById(brand, { personal_offers });
        } else if (offer_type === "business") {
          business_offers.push(offer);
          this.setState({ business_offers });
          Firebase.updateBrandDataById(brand, { business_offers });
        }
        this.setState({ loading: false });
      }
    );
  };
  render() {
    const {
      logo,
      brand,
      is_property_brand,
      is_business_offers_need,
      offer_type,
      brand_name,
    } = this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          {is_business_offers_need && (
            <SwitchBar switchOffer={this.switchOffer} offer_type={offer_type} />
          )}
          {offer_type === "personal" && this.showPersonalOffer()}
          {offer_type === "business" && this.showBusinessOffer()}
        </main>
        <AddOfferModal addOffer={this.addOffer} />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapActionToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapActionToProps)(Offer);



// WEBPACK FOOTER //
// ./src/screens/Offers/index.js